import { api, ApiError } from '@/lib/api';
import type { TrainingReport, UpsertTrainingReportInput } from './types';

/** The session's report, or null if the trainer hasn't started one yet (404). */
export async function fetch_training_report(booking_id: string): Promise<TrainingReport | null> {
  try {
    const res = await api.get<TrainingReport>(`/vendor/bookings/${booking_id}/training-report`);
    return res.data;
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }
}

export async function save_training_report(booking_id: string, input: UpsertTrainingReportInput): Promise<TrainingReport> {
  const res = await api.put<TrainingReport>(`/vendor/bookings/${booking_id}/training-report`, input);
  return res.data;
}

export async function publish_training_report(booking_id: string): Promise<TrainingReport> {
  const res = await api.post<TrainingReport>(`/vendor/bookings/${booking_id}/training-report/publish`);
  return res.data;
}

/** Owner read — the published session report for a booking, or null (404 while DRAFT/none). */
export async function fetch_owner_training_report(booking_id: string): Promise<TrainingReport | null> {
  try {
    const res = await api.get<TrainingReport>(`/user/bookings/${booking_id}/training-report`);
    return res.data;
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }
}
